import styled from "styled-components";
import { colorsPalettes } from "@similarweb/styles";
import type { IconName } from "@similarweb/icons";
import { SWReactIcons } from "@similarweb/icons";
import I18n from "pro-features/components/WithTranslation/src/I18n";
import type { ComponentProps, FC, FunctionComponent } from "react";

export const DisclaimerContainer = styled.div`
    padding: 10px;
    background-color: ${colorsPalettes.sky[100]};
    color: ${colorsPalettes.carbon[400]};
    border-radius: 6px;
    display: flex;
    align-items: center;
    margin: 12px 0px 0px;
`;
const TextWrapper = styled.div`
    margin-left: 4px;
`;

interface IDisclaimerProps {
    disclaimerText: string;
    icon?: IconName;
    ContentContainer?: FunctionComponent<ComponentProps<typeof DisclaimerContainer>>;
}

export const Disclaimer: FC<IDisclaimerProps> = ({
    disclaimerText,
    icon = "info",
    ContentContainer = DisclaimerContainer,
}) => {
    return (
        <ContentContainer>
            <SWReactIcons
                iconName={icon}
                size="xs"
            />
            <TextWrapper>
                <I18n>{disclaimerText}</I18n>
            </TextWrapper>
        </ContentContainer>
    );
};
